import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SUPPORTED_LOCALES = ["en", "fr"];

export const Route = createFileRoute("/$locale")({
  component: LocaleLayout,
});

function LocaleLayout() {
  const { locale } = Route.useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (SUPPORTED_LOCALES.includes(locale) && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  if (!SUPPORTED_LOCALES.includes(locale)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p>Unsupported locale: {locale}</p>
      </div>
    );
  }

  return <Outlet />;
}
